import { format } from 'date-fns'

export const toHumanReadable = (date) => format(new Date(date), 'MMMM d, yyyy')
